import * as React from 'react';
import { mergeStyleSets, FontSizes, FontWeights } from '@fluentui/react';

export interface TitleProps {
	children: JSX.Element | string
	id?: string
}

export const Title = ({ children, id }: TitleProps) => {
	return <h2 id={id} className={styles.root}>{children}</h2>;
};

const styles = mergeStyleSets({
	root: {
		fontSize: FontSizes.size20,
		lineHeight: '2.25rem',
		marginBottom: '1rem',
		marginTop: 0,
		fontWeight: FontWeights.semibold
	}
});
